module.exports = __webpack_public_path__ + "static/media/7. En medio del abismo, Acrílico y óleo en tela, 90 x 190 cm, 2019 copy.9bf7a239.png";